document.addEventListener('DOMContentLoaded', function() {
  const productFormComponent = document.querySelector('product-form');
  if (!productFormComponent) return;

  const form = productFormComponent.querySelector('form[action*="/cart/add"]');
  if (!form) return;

  const nameinput = document.querySelector('.nameinput');
  if (!nameinput.children.length) return;

  const addBtn = form.querySelector('button[type="submit"], .product-form__submit');
  if (!addBtn) return;

  // 🎯 必須対象をクラス指定で取得
  const textInputs = document.querySelectorAll('.custom-required');
  const checkboxes = document.querySelectorAll('.custom-consent');
  const radios = document.querySelectorAll('.custom-consent_radio');

  // ✅ 初期状態ではボタン無効化
  addBtn.disabled = true;

  // 必須項目の全チェック
  const validateAll = () => {
    let allValid = true;
    const groups = {};

    textInputs.forEach((input) => {
      if (!input.value.trim()) {
        allValid = false;
        input.classList.remove('valid');
      }
      else{
        input.classList.add('valid');
      }
    });

    checkboxes.forEach((checkbox) => {
      if (!checkbox.checked) {
        allValid = false;
        checkbox.classList.remove('valid');
      }
      else{
        checkbox.classList.add('valid');
      }
    });

    radios.forEach(radio => {
      if (!groups[radio.name]) {
        groups[radio.name] = [];
      }
      groups[radio.name].push(radio);
    });
  
    Object.keys(groups).forEach(name => {
      const group = groups[name];
      const checked = group.some(radio => radio.checked);

      if (!checked) {
        allValid = false;
        group.forEach(radio => radio.classList.remove('valid'));
      } else {
        group.forEach(radio => radio.classList.add('valid'));
      }
    });

    return allValid;
  };

  // ✅ ボタンの状態更新
  const updateButtonState = () => {
    addBtn.disabled = !validateAll();
  };

  // 入力/変更で都度チェック
  textInputs.forEach((input) => {
    input.addEventListener('input', updateButtonState);
  });

  checkboxes.forEach((checkbox) => {
    checkbox.addEventListener('change', updateButtonState);
  });

  radios.forEach((radio) => {
    radio.addEventListener('change', updateButtonState);
  });

  // ✅ ボタンクリック時の最終確認
  addBtn.addEventListener(
    'click',
    function (e) {
      if (!validateAll()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        alert('お名前・和歴生年月日は必須入力項目となっております。\nすべての情報をご確認いただけましたらチェックボックスにチェックをお願いいたします。');
        return false;
      }
      // OKならそのままテーマの送信へ
    },
    true
  );

  // ✅ ページロード直後にも初期チェック
  updateButtonState();
});
